import { render, staticRenderFns } from "./PackingConfirmation.vue?vue&type=template&id=4a4d87d0&scoped=true&"
import script from "./PackingConfirmation.vue?vue&type=script&lang=js&"
export * from "./PackingConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PackingConfirmation.vue?vue&type=style&index=0&id=4a4d87d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4d87d0",
  null
  
)

export default component.exports